import { useState } from "react";
import { FiX } from "react-icons/fi";
import EpisodeEditor from "../EpisodeEditor";
import Button from "../ui/Button";

export default function EpisodeEditorModal({onClose, episode}) {
    const [newEpisode, setNewEpisode] = useState(episode || {
        name: 'New Episode',
        description: ''
    })

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4 items-center'>
                <span className='text-white text-lg font-bold'>Episode</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden'>
                <EpisodeEditor defaultValue={newEpisode} onChange={(episode) => setNewEpisode(episode)} />
            </div>
            <div className='flex p-2 gap-4'>
                <Button type='primary' className='min-w-20' onClick={() => onClose(newEpisode)}>Save</Button>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
            </div>
        </div>
    )
}